import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// 🔥 SENİN FIREBASE CONFIG'İN
const firebaseConfig = {
  apiKey: "AIzaSyDJ4GPVdjw_mmsRtZZoLoDpHSMCuXJZ9rQ",
  authDomain: "deneme-91136.firebaseapp.com",
  projectId: "deneme-91136",
  storageBucket: "deneme-91136.appspot.com",
  messagingSenderId: "382960314700",
  appId: "1:382960314700:web:69c4e9301c6bbbf127c7e9",
  measurementId: "G-XMD47ZJEJK"
};

// 1. Firebase'i başlat
export const app = initializeApp(firebaseConfig);

// 2. Firebase servisleri
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// 3. App ID (senin admin panelde kullandığın)
export const appId = "fecosfood-prod";
